/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import KhVueSolo from './KhVueSolo.vue'
export * from './KhVueSolo.vue'
export default KhVueSolo
